// extracted by mini-css-extract-plugin
export default {"green":"pga2_green__a+mct","box":"pga2_box__7H8t5","grid":"pga2_grid__uIlV0","pgalogo":"pga2_pgalogo__Ijd14","statsGrid":"pga2_statsGrid__bu+5w","twitter":"pga2_twitter__0i4rA"};